import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import { type ZocksUiHeading } from '../zocksUi'
import { GroupHeading } from './GroupHeading'

interface ParameterSectionProps {
  heading: ZocksUiHeading | null
  divider: boolean
  children: ReactNode
}

export const ParameterSection: FC<ParameterSectionProps> = ({ heading, divider, children }) => {
  const className = classNames('d-flex flex-column', { 'border-top pt-4': divider })
  return heading ? (
    <section className={className} aria-label={heading.title}>
      <GroupHeading title={heading.title} description={heading.description} titleClassName='heading-small' titleAs='h6' className='mb-3' />
      {children}
    </section>
  ) : (
    <div className={className}>{children}</div>
  )
}
